import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import FirearmsG4 from "./FirearmsG4";
import NotFoundPage from "./NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/firearms-potentially-affected-by-amendment-g4"
        element={<FirearmsG4 />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
